import React from 'react';
const WhyMachineLearning = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Machine Learning Models Now?
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            The explosion of data across industries has created immense opportunities to turn information into predictive intelligence. Modern enterprises need Machine Learning and MLOps to automate insights, reduce human error, and maintain a competitive advantage through proactive decision-making. Delayed insights now carry real costs, missed opportunities, inefficiencies, and unoptimized operations.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-0 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Businesses often rely on reactive decisions and manual forecasting, resulting in inaccuracies, scalability issues, and overlooked growth patterns. With enterprise Machine Learning solutions, organizations can move from hindsight to foresight, predicting equipment failures before breakdowns, detecting fraud early, identifying high-value customer segments, forecasting demand in real time, and optimizing pricing dynamically. Whether through regression analysis, classification models, or anomaly detection, ML helps unlock hidden value within data at scale.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WhyMachineLearning;
